import React, {CSSProperties, ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import AnnotationRectangle from "./AnnotationRectangle";
import {
	Annotation,
	AnnotationPointPoint,
	AnnotationPointPointInterface, BorderStyle,
	Markup,
	MetadataRectangle
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class InkAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let points: Array<AnnotationPointPoint> = this.getPoints();
		let lineBoundaries: MetadataRectangle = this.getLineBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		if (points.length > 0) {
			lineBoundaries.width! -= lineBoundaries.x!;
			lineBoundaries.height! -= lineBoundaries.y!;

			let result: Array<AnnotationPointPoint> = [];
			for (let point of points) {
				result.push(AnnotationPointPoint.fromJson({
					x: point.x! - lineBoundaries.x!,
					y: lineBoundaries.height! - (point.y! - lineBoundaries.y!)
				} as AnnotationPointPointInterface));
			}

			points = result;
		}

		let annotationStyle: CSSProperties = {
			opacity: FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100,
			stroke: color,
			strokeLinejoin: "round"
		};

		if (FunctionHelper.exists(annotation.border)) {
			annotationStyle.fill = annotation.border!.interiorColor;
			annotationStyle.strokeWidth = annotation.border!.width!.toString();

			if (annotation.border!.style === BorderStyle.Dashed) {
				annotationStyle.strokeDasharray = JSON.parse(annotation.border!.dashPattern!).join(",");
			}
		}

		return (
			<AnnotationRectangle {...this.props} {...lineBoundaries} popupContent={annotation.contents}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				<svg xmlns={SVG_NAMESPACE}>
					<polyline points={points.map(point => point.x + "," + point.y).join(" ")} style={annotationStyle}/>
				</svg>
			</AnnotationRectangle>
		);
	}
}